import React from "react";
import { Redirect, Route } from "react-router-dom";
import { AccountTabletLinkovi } from './AccountTabletLinkovi.jsx';
import { Header } from '../Layout/Header.jsx';
import { MetaTags } from '../Layout/MetaTags.jsx';
import { RestrictedAccess } from '../../Components/Layout/RestrictedAccess.jsx';

export class PostavkePrivatnosti extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            skrivenNadimak: null,
            promjena: false,
            spremljeno: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
        const { user } = this.props;
        if (this.props.user && user.skriveniNadimak != undefined) {
            this.setState({ skrivenNadimak: user.skriveniNadimak });
        }
    };

    componentDidUpdate(prevProps) {
        const { user } = this.props;
        if (user !== prevProps.user && user && user.skriveniNadimak !== undefined) {
            this.setState({ skrivenNadimak: user.skriveniNadimak });
        }
    };

    handleSubmit = (e) => {
        const { skrivenNadimak } = this.state;
        casino.repos.casinoSkrivenNadimakRepo.set(skrivenNadimak);
        this.setState({
            promjena: false,
            spremljeno: true
        });
        setTimeout(() => {
            this.setState({ spremljeno: false });
        }, 3000);
    };

    render() {
        if (this.props.user)
            return (
                <div className="postavke-privatnosti">
                    <MetaTags title="Postavke privatnosti | SuperSport Casino" description={" "} />
                    <Route exact path={this.props.route.match.url} render={(route) =>
                        (<Header key="header" {...this.state} {...this.props} detailsHeader="true" headerText={"Postavke privatnosti"} headerBackUrl={this.props.getHomePathFn(this.props.route.location, '/account')}></Header>)} />

                    <div className="flex margin-1p-on-tablet">
                        {this.props.user && <AccountTabletLinkovi {...this.props} ></AccountTabletLinkovi>}

                        <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding" style={{ minHeight: '446px' }}>

                            <div className="back-button-container">
                                <button onClick={() => location.href = 'https://mcasino.supersport.hr/account'} className="back-button"><span className="arrow-back-transparent"></span> Povratak</button>
                            </div>

                            <div className="header-container">
                                <h1 className="text">Postavke privatnosti</h1>
                            </div>

                            <div className="clearfix flex-equal-size maximum settings-container">

                                <div className="" style={{ minHeight: '350px' }}>

                                    <div className="prikaz-imena">Prikaz imena</div>

                                    <p className="prikaz-imena-text">
                                        Prilagođavaj postavke prikaza svog imena na stranici Super Casino. Tvoje ime se prikazuje u slučaju velikog dobitka ili jackpota. Odaberi jedan od donjih načina prikaza:
                                    </p>

                                    <div className="flex-container-prikaz-imena">

                                        <form>
                                            <label className="custom-radio-btn">
                                                <input
                                                    type="radio"
                                                    id="vidljivo-prvo-i-zadnje-slovo-imena"
                                                    name="ime"
                                                    value="Vidljivo prvo i zadnje slovo imena"
                                                    checked={this.state.skrivenNadimak != null ? this.state.skrivenNadimak : false}
                                                    onChange={() => this.setState({
                                                        skrivenNadimak: true,
                                                        promjena: true,
                                                        spremljeno: false
                                                    })}
                                                ></input>
                                                <span className="checkmark"></span>
                                                <span className="checkmark-border"></span>
                                                Vidljivo prvo i zadnje slovo imena
                                            </label>
                                            <br></br>

                                            <span className="primjer prvo-i-zadnje">npr: {this.props.user ? this.props.user.ime[0] : ""}...{this.props.user ? this.props.user.ime[this.props.user.ime.length - 1] : ""}</span>
                                            <br></br>

                                            <label className="custom-radio-btn">
                                                <input
                                                    type="radio"
                                                    id="potpuno-vidljivo-ime"
                                                    name="ime"
                                                    value="Potpuno vidljivo ime"
                                                    checked={this.state.skrivenNadimak != null ? !this.state.skrivenNadimak : false}
                                                    onChange={() => this.setState({
                                                        skrivenNadimak: false,
                                                        promjena: true,
                                                        spremljeno: false
                                                    })}
                                                ></input>
                                                <span className="checkmark"></span>
                                                <span className="checkmark-border"></span>
                                                Potpuno vidljivo ime
                                            </label>
                                            <br></br>

                                            <span className="primjer">npr: {this.props.user ? this.props.user.ime : ""}</span>
                                        </form>
                                    </div>

                                    <div className="super-save-button-container">
                                        <button onClick={this.handleSubmit} type="submit" className={this.state.promjena ? "super-save-button" : "super-save-button-opacity"}>SPREMI PROMJENE</button>
                                        {this.state.spremljeno ? < div className="saved-message"><span className="saved-checkmarks"></span> SPREMLJENO</div> : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )

        else {
            return (
                <>
                    <Header key="header" {...this.state} {...this.props} />
                    <RestrictedAccess {...this.props} />
                </>
            )
        }
    }
}